import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {FormGroup, Input, Label} from "reactstrap"
import compareColor from "../../helpers/compareColor"
import compareSize from "../../helpers/compareSize"

class FilterSelect extends Component {
    _handleChangeColor = (e) => {
        const {name, value} = e.target
        const {onChange} = this.props

        if (typeof onChange === 'function') {
            onChange(name, value)
        }
    }

    render() {
        const {value, lists, field, name} = this.props

        let data = lists
        if (field === 'Size') {
            data = lists.sort(compareSize)
        } else if (field === 'Color') {
            data = lists.sort(compareColor)
        } else if (field === 'Type') {
            data = lists.sort()
        }

        return (
            <FormGroup>
                <Label>{field}</Label>
                <Input type='select' name={name}
                       value={value || 'All'}
                       onChange={this._handleChangeColor}>
                    <option value='All'>All</option>
                    {
                        data.map(item => {
                            if (typeof item === 'object' && !!item) {
                                return <option key={item.value} value={item.value}>{item.name}</option>
                            }
                            return <option key={item}>{item}</option>
                        })
                    }
                </Input>
            </FormGroup>
        )
    }
}

FilterSelect.propTypes = {
    value: PropTypes.string,
    lists: PropTypes.array.isRequired,
    field: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired
}

export default FilterSelect
